/* eslint no-bitwise: 0 */

/* Must match GoFormz.Common.Services.Core/GoFormz.Common.Services.Core/Enums/Permission.cs */
export const enum Operations {
  Read = 1,
  ReadAll = 2,
  ViewReports = 11,
  CanLoginToManagment = 12, // Not used, should be removed from all repos
  ViewTemplates = 13,
  PublicShare = 14,
  FormCopy = 15,
  FormRename = 16,
  FormTransfer = 17,
  FormDelete = 18,
  FormEdit = 19,
  FormComplete = 20,
  FormDeleteDrafts = 21,
  FormDownloadPDF = 22,
  FormTags = 23,
  TagCreate = 24,
  TagManage = 25,
  ManageDataSources = 26,
  ManageWorkflows = 27,
  ManageUsersGroups = 28
}

export enum Settings {
  SkipDashboard = 'skipDashboard',
  SkipPublishedTemplatePrompt = 'skipPublishedTemplatePrompt',
  SkipAddTemplateFieldsModal = 'skipAddTemplateFieldsModal',
  ExportDelimiter = 'exportDelimiter',
  ExportNewlines = 'exportNewlines',
  ExportTimezone = 'exportTimezone',
  ExportDateFormat = 'exportDateFormat'
}
